import React from 'react'
import { useEntitlements } from '../../contexts/EntitlementsContext'
import { UpsellScreen } from './Upsell'

// Envuelve una ruta de módulo. Si el plan no lo incluye, muestra la pantalla de upsell.
const RequireModule = ({ feature, children }) => {
  const { hasModule, loading } = useEntitlements()
  if (loading) return null
  return hasModule(feature) ? children : <UpsellScreen feature={feature} />
}

export default RequireModule
